<template>
    <v-app style="background-color:#FAFAFA">
        <router-view></router-view>    
        <loadingcomponent :is_loading="$store.getters.loading" />    
    </v-app>
    
</template>
<style scoped>
#app{
  background-color: #fafafa;
}
</style>
<script>
import loadingcomponent from  './components/shared/loading.vue'

export default {
  name: 'App',
  components: {
    loadingcomponent
  },
  data: () => ({
    //
  }),
  methods:{
    
  }
};
</script>
